export const CAMPAIGNS = {
    CREATE_NEW: "create-new",
    SUBJECT: "subject",
    SEND: "send",
    TEST: "test",
    DRAFT: "draft",
    SEND_AS_EZORDER: "send-as-ezorder",
    SEND_FILTERED_PRODUCTS_ONLY: "send-filtered-products-only",
    CONTACT_SEARCH_INPUT: "contact-search-input",
    RECIPIENT_NAME: "recipient-name",
    INCLUDE_XLSX: "campaign-include-xlsx",
    INCLUDE_PDF: "campaign-include-pdf",
    PDF_TEMPLATE: "pdf-template-dropdown",
    SIXTEEN_PRODUCTS_LANDSCAPE: "landscape_single_16",
    FIVE_PRODUCT_LANDSCAPE: "landscape_5",
    FOUR_PRODUCT_LANDSCAPE: "landscape_single_4",
    FOUR_PRODUCT_LANDSCAPE_WITH_INVENTORY: "landscape_single_4i",
    FOUR_PRODUCT_PORTRAILT: "portrait_4",
    EIGHT_PRODUCT_LANDSCAPE: "landscape_8",
    TWO_PRODUCT_LANDSCAPE: "landscape_2",
    TWO_PRODUCT_LANDSCAPE_WITH_INVENTORY: "landscape_2i",
    CAMPAIGN_LIST_ROW: "campaign-list-row",
    CAMPAIGN_CATALOG: "campaign-catalog",
    CAMPAIGN_SUBJECT_TEXT: "campaign-subject-text",
    CAMPAIGNS_DETAILS_DATA_CONTAINER: "campaign-details-data",
    CONVERSION_DATA_CONTAINER: "conversion-data-container",
    LINE_ITEM_PRICE: "line-item-price",
    PDF_DOWNLOAD_LINK: "pdf-download-link",
    XLS_DOWNLOAD_LINK: "xls-download-link",
    VIEW_EZORDER: "view-ezorder",
    EZORDER_PRODUCT_CELL: "product-cell",
    EZORDER_PRODUCT_DETAILS_WHOLESALE: "price-wholesale",
    EZORDER_PRODUCT_DETAILS_RETAIL: "price-retail",
    EZORDER_CHOOSE_QUANTITIES: "choose-quantities-btn",
    EZORDER_SELECT_ALL: "select-all-btn",
    EZORDER_PRODUCT_ADD_TO_ORDER: "add-to-order",
    EZORDER_SUBMISSION_WHOLESALE: "submission-wholesale-price",
    EZORDER_SUBMISSION_RETAIL: "submission-retail-price",
    EZORDER_SUBMISSION_LINE_ITEM: "ezorder-line-item",
    EZORDER_SUBMISSION_TOTALS: "ezorder-totals",
    RECIPIENTS: {
        ROW: "recipient-row",
        COMPANY_NAME: "company-name",
        BUYER_NAME: "buyer-name",
        LAST_ACTION_DATE: "last-action-date",
        STATUS: "status",
    },
};
